export default "__VITE_ASSET__B2FZ83yO__"